import { combineReducers } from "redux";
import about_us from "../features/admin/profile_feed/about_us/slice";
import terms_and_condition from "../features/admin/profile_feed/terms_and_condition/slice";
import privacy_policy from "../features/admin/profile_feed/privacy_policy/slice";
import refund_policy from "../features/admin/profile_feed/refund_policy/slice";

const profile_feed = combineReducers({
  about_us: about_us,
  terms_and_condition: terms_and_condition,
  privacy_policy: privacy_policy,
  refund_policy: refund_policy,
});

export default profile_feed;
